import React from 'react'

import './Pawns.css'

const colors = {
  red: '#D0021B',
  green: '#B8E986',
  blue: '#4A90E2'
}

const Pawns = (props) => {
  const style = {
    width: `${props.size}px`,
    height: `${props.size}px`
  }

  const squareSize = props.size / props.squares

  return (
    <div className={`pawns`} style={style}>
      {
        props.pawns.map(({id, color, row, column, alive}) => {
          let pawnStyle = {
            width: `${Math.min(10, squareSize)}px`,
            height: `${Math.min(10, squareSize)}px`,
            backgroundColor: colors[color],
            transform: `translate(${squareSize * row}px, ${squareSize * column}px)`
          }
          if (props.speed > 50) {
            pawnStyle.transition = `transform ${(props.speed / 4 * 3)}ms linear`
          }

          if (!alive) {
            pawnStyle.opacity = 0.5
            pawnStyle.backgroundColor = ''
            pawnStyle.border = `1px solid ${colors[color]}`
            pawnStyle.zIndex = -1
          }
          return (
            <div
              key={id}
              className={`pawn pawn--${color}`}
              style={pawnStyle}
            />
          )
        })
      }
    </div>
  )
}

export default Pawns


// WEBPACK FOOTER //
// ./src/components/Pawns.js